var map = {
	"./Arial/ArialRegular/ArialRegular.woff2": 95576,
	"./ArialNovaCond/ArialNovaCondRegular/ArialNovaCondRegular.woff2": 91727,
	"./EuclidCircularA/EuclidCircularARegular/EuclidCircularARegular.woff2": 61357,
	"./Geometria/GeometriaRegular/GeometriaRegular.woff2": 36255,
	"./Manrope/ManropeRegular/ManropeRegular.woff2": 28973,
	"./Montserrat/MontserratRegular/MontserratRegular.woff2": 79228,
	"./PTMono/PTMonoRegular/PTMonoRegular.woff2": 80793,
	"./PTSans/PTSansRegular/PTSansRegular.woff2": 8115,
	"./Roboto/RobotoRegular/RobotoRegular.woff2": 56067,
	"./Rooftop/RooftopRegular/RooftopRegular.woff2": 27681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7632;